import { gql } from '@apollo/client';

export default gql`
  fragment Role on Role {
    _id
    name
  }
`;
